<template>
  <question-base-wrapper v-bind="baseWrapperProps">
    <validation-provider
      v-slot="{ errors,failedRules }"
      :rules="postcodeCustomRules"
      :name="questionId"
      :vid="`${stepId}_${questionId}`"
    >
      <text-input
        v-model="questionData[questionFields.field]"
        :placeholder="postcodePlaceholder"
        :text-transform="textTransform"
        :error-messages="getFieldErrors('field', failedRules, errors)"
        :max-length="maxLength"
        :data-test="questionFields.field"
      />
    </validation-provider>
  </question-base-wrapper>
</template>

<script>
import QuestionBaseText from './BaseText';
import QuestionBaseWrapper from './BaseWrapper';
import TextInput from '@/components/TextInput/TextInput';

export default {
  name: 'question-business-postcode',
  extends: QuestionBaseText,
  components: {
    QuestionBaseWrapper,
    TextInput,
  },
  computed: {
    postcodePlaceholder () {
      return this.helpers.getPostcodeExample(this.config.customValidations?.postcode?.startsWith);
    },

    postcodeCustomRules () {
      const { postcode, ...fieldRules } = this.validationRules?.field;

      return {
        postcode: { ...postcode, ...this.config.customValidations?.postcode },
        ...fieldRules,
      };
    },
  },
};
</script>
